import { Component, OnInit } from '@angular/core';
import { Router }            from '@angular/router';
import { Observable }        from 'rxjs/Observable';
import { Subject }           from 'rxjs/Subject';
import { Input } from '@angular/core';



import { UserService } from '../../services/users/user.service';


@Component({
  moduleId: module.id,
  selector: 'user-search',
  templateUrl: 'user-search.component.html',
  styleUrls: [ 'user-search.component.css' ]
})

export class UserSearchComponent implements OnInit {
  @Input() hide:boolean=false;;
  users: Observable<any[]>;
  protected searchTerms = new Subject<string>();

  constructor(
    protected router: Router,
    protected userService: UserService) {}

  protected getDetailUrl(): string { return; };
  protected getUserString(): string { return; };

  // Push a search term into the observable stream.
  search(term: string): void {

    this.searchTerms.next(term);
  }

  ngOnInit(): void {

    this.users = this.searchTerms
      .debounceTime(300)        // wait for 300ms pause in events
      .distinctUntilChanged()   // ignore if next search term is same as previous
      .switchMap(term => term   // switch to new observable each time
        // return the http search observable
        ? this.userService.search({ name: term })
        // or the observable of empty users if no search term
        : Observable.of<any[]>([]))
      .catch(error => {
        // TODO: real error handling
        console.log(error);
        return Observable.of<any[]>([]);
      });
  }

  gotoDetail(user: any): void {
    
    this.router.navigate([ this.getDetailUrl() + user.id ]);
  }
}



// WEBPACK FOOTER //
// ./src/app/users/search/user-search.component.ts